import InfoTicketLiveEventComponent from "./InfoTicketLiveEventComponent";

export default InfoTicketLiveEventComponent;